import { Injectable } from '@angular/core';

const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';
const CSV_TYPE = 'text/plain;charset=utf-8';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor() {}

  /**
   * Creates an array of data to csv. It will automatically generate title row based on object keys.
   *
   * @param rows array of data to be converted to CSV.
   * @param fileName filename to save as.
   * @param columns array of object properties to convert to CSV. If skipped, then all object properties will be used for CSV.
   */
  public exportToCsv(rows: object[], fileName: string, columns?: string[], includeAllColumes = false): void {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0])
      .filter((k) => {
        if (columns?.length && includeAllColumes) {
          return columns.includes(k);
        } else {
          return true;
        }
      })
      .map((x: any) => {
        let f = columns?.find((y: any) => y.key === x);
        if (f) {
          return x.name;
        }

        return x;
      });
    const csvContent =
      keys.join(separator) +
      '\n' +
      rows
        .map((row: any) => {
          return keys
            .map((k) => {
              let cell = row[k] === null || row[k] === undefined ? '' : row[k];
              cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');
              if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`;
              }
              return cell;
            })
            .join(separator);
        })
        .join('\n');
    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE);
  }

  /**
   * Creates an array of data to csv. It will automatically generate title row based on object keys.
   *
   * @param rows array of data to be converted to CSV.
   * @param fileName filename to save as.
   * @param columns array of object properties to convert to CSV. If skipped, then all object properties will be used for CSV.
   */
  public exportToCsvV2(
    rows: object[],
    fileName: string,
    columns: string[],
    columnsMeta: any[],
    header: { mainHeading: string; subHeading: string } = { mainHeading: '', subHeading: '' }
  ): void {
    if (!rows || !rows.length) {
      return;
    }
    rows = this.reorderRows(rows, columns);
    const names: any = [];
    const separator = ',';
    const keys = Object.keys(rows[0])
      .filter((k) => {
        if (columns?.length) {
          return columns.includes(k);
        } else {
          return true;
        }
      })
      .map((x: any) => {
        let f = columnsMeta.find((y: any) => y.key === x);
        if (f) {
          names.push(f.name);
        } else {
          names.push(x);
        }

        return x;
      });
    const csvContent =
      (header.mainHeading ? header.mainHeading + '\n' : '') +
      (header.subHeading ? header.subHeading + '\n' : '') +
      names.join(separator) +
      '\n' +
      rows
        .map((row: any) => {
          return keys
            .map((k) => {
              let cell = row[k] === null || row[k] === undefined ? '' : row[k];
              cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');
              if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`;
              }
              return cell;
            })
            .join(separator);
        })
        .join('\n');
    // console.log(new Date().toLocaleString() + '  ➤  csvContent ==> ', csvContent);
    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE);
  }
  reorderRows(rows: object[], columns: string[]): object[] {
    return rows.map((row: any) =>
      columns.reduce((rowObject: any, column: any) => {
        if (row.hasOwnProperty(column)) rowObject[column] = row[column];
        return rowObject;
      }, {})
    );
  }
  // public exportToExcel(rows: object[], fileName: string): void {
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
  //   //const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  //   const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   this.saveAsFile(excelBuffer, `${fileName}${CSV_EXTENSION}`, EXCEL_TYPE);
  // }

  private saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const blob = new Blob([buffer], { type: fileType });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
  }
}
